import { Box, Card, Stack, Typography } from "@mui/material"
import { SimilaritySummaryValue } from "./similarity-summary-value"
import { useSimilaritySelection } from "./similarity-selection-context"
import { SimilaritySelectionSummaryValue } from "./similarity-selection-summary-value"

export function SimilaritySummaryCard({ availableCount = 0, lockedCount = 0, sx = {} }) {
    const { selectedCount, schedulesAffected } = useSimilaritySelection()

    return (
        <Card data-cy="similarity-summary-card" sx={{ p: 3, display: "flex", ...sx }}>
            <Stack spacing={1.5} sx={{ flex: 1 }}>
                <Typography variant="h6">Similarity Results</Typography>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
                        gridAutoRows: "1fr",
                        gap: 1.5,
                        flex: 1,
                    }}
                >
                    <SimilaritySummaryValue
                        label="Available"
                        value={availableCount}
                        dataCy="available-count"
                        icon="mdi:checkbox-marked-circle-outline"
                        palette="success"
                    />
                    <SimilaritySummaryValue
                        label="Locked"
                        value={lockedCount}
                        dataCy="locked-count"
                        icon="mdi:lock-outline"
                        palette="warning"
                    />
                    <Box sx={{ gridColumn: "1 / -1" }}>
                        <SimilaritySelectionSummaryValue
                            selectedCount={selectedCount}
                            schedulesCount={schedulesAffected}
                        />
                    </Box>
                </Box>
            </Stack>
        </Card>
    )
}
